type SessionStorageObj = {
  get: (arg0: string) => string | null;
  set: (arg0: string, arg1: string) => void;
  remove: (arg0: string) => void;
};

const sessionStorage: SessionStorageObj = {
  get(key: string) {
    try {
      return window.sessionStorage?.getItem(key);
    } catch {
      return null;
    }
  },

  set(key: string, val: string) {
    try {
      if (window.sessionStorage) window.sessionStorage.setItem(key, val);
    } catch {
      // do nothing
    }
  },

  remove(key: string) {
    try {
      if (window.sessionStorage) window.sessionStorage.removeItem(key);
    } catch {
      // do nothing
    }
  },
};

export default sessionStorage;
